import { Component } from "@angular/core";
import { AlertController } from '@ionic/angular';

import { Platform } from "@ionic/angular";
import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { StatusBar } from "@ionic-native/status-bar/ngx";
import { Router } from "@angular/router";
import { OneSignal } from "@ionic-native/onesignal/ngx";
import { environment } from "src/environments/environment";
import { TranslateService } from "@ngx-translate/core";
import { GoogleMapService } from "./services/google-map.service";
import { NavController } from "@ionic/angular";

@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
})
export class AppComponent {
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private router: Router,
    private oneSignal: OneSignal,
    private translate: TranslateService,
    private googleMaps: GoogleMapService,
    private navCtrl: NavController,
    public alertController: AlertController
  ) {
    if(localStorage.getItem("updated") != "yess"){
      localStorage.clear();
      sessionStorage.clear()
      localStorage.setItem("updated", "yess");
    }
    const lng = localStorage.getItem("language");
    if (!lng || lng === null) {
      localStorage.setItem("language", "en");
    }
    this.translate.use(localStorage.getItem("language"));
    this.initializeApp();

    localStorage.setItem("selectedCountry", "IE");
    /* this.checkFb() */

  }
  checkFb(){

    if(this.isFacebookApp()){
      this.presentAlert()
  }
  }
  async presentAlert() {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Alert',
      subHeader: 'Mayoeats Alert',
      message: 'Please open with with external browser.',
      buttons: ['OK']
    })
    alert.onDidDismiss()
          .then(data => {
            window.location.href = "intent:https://mayoeats.ie/category?id=nG71tLN52oTf22ibgOODnbVW4Cr1;end";
          },
          err => {
            console.log(err);
          });

    await alert.present();
  }

  
  isFacebookApp() {
    var ua = navigator.userAgent || navigator.vendor;
    return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);
}

  initializeApp() {
    this.platform.ready().then(() => {
      /* var OneSignal = window['OneSignal'] || [];
      OneSignal.push(function () {
        OneSignal.init({
          appId: "e42fc8b1-b50e-40f4-bad9-903f748765b5",
          safari_web_id: "web.onesignal.auto.4c35e1cb-920a-4e68-be7d-eea8363a1cf4",
          autoRegister: false,
          allowLocalhostAsSecureOrigin: true,
          notifyButton: {
            enable: false
          }
        });
      });
      console.log('OneSignal Initialized');
      OneSignal.push(function () {
        console.log('Register For Push');
        OneSignal.push(["registerForPushNotifications"])
      });
      OneSignal.getIdsAvailable(function (ids) {
        localStorage.setItem("fcm", ids.userId);
        console.log("getIdsAvailable:"
          + "\nUserID: " + ids.userId
          + "\nRegistration ID: " + ids.registrationId);
      }); */
      /**setTimeout(async () => {
        await this.oneSignal.startInit(
          environment.onesignal.appId,
          environment.onesignal.googleProjectNumber
        );
        this.oneSignal.getIds().then((data) => {
          localStorage.setItem("fcm", data.userId);
        });
        await this.oneSignal.endInit();
      }, 1000);**/
      
      this.platform.backButton.subscribe(async () => {
        console.log(
          "asd",
          this.router.url,
          "ad",
          this.router.isActive("/tabs/", true)
        );
        if (
          this.router.url.includes("/tabs/") ||
          this.router.url.includes("/login")
        ) {
          navigator["app"].exitApp();
        }
      });
      this.statusBar.backgroundColorByHexString("#d6e9d8");
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }
}
